<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="OT" id="_idParaDest-3"><a href="#/Schroeder_Genesis_text_CC2#toc2"></a><a id="_idTOCAnchor-3"></a>Abbreviations</p>
<p class="AB">CCCM	Corpus Christianorum, Continuatio Mediaevalis. Turnhout: Brepols, 1966-­.</p>
<p class="AB">CCSL	Corpus Christianorum, Series Latina. Turnhout: Brepols, 1953-­.</p>
<p class="AB">CSEL	Corpus Scriptorum Ecclesiasticorum Latinorum. 85 vols. Vienna, 1866. New York: Johnson Reprint, 1961.</p>
<p class="AB">FC	Fathers of the Church. Washington, D.C.: Catholic University of America Press, 1947-­.</p>
<p class="AB">LCL	Loeb Classical Library. Cambridge, Mass.: Harvard University Press.</p>
<p class="AB">NRSV	New Revised Standard Version Bible.</p>
<p class="AB">PL	Patrologia Latina. 221 vols. Ed. J.-­P Migne. Paris, 1844-55.</p>
<p class="AB">SC	Sources Chrétiennes. Paris: Éditions du Cerf, 1941-­.</p>
<p class="AB"><em class="italic">SH</em>	Peter Comestor, <em class="italic">Scholastica Historia</em> [= <em class="italic">Scholastic History</em>].</p>
<p class="AB"><em class="italic">ST</em>	Thomas Aquinas, <em class="italic">Summa Theologiae.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Schroeder_Genesis_text_CC-4.vue?a0880888